const KEY = "sht_landing_page";
const AD_KEY = "sht_ad_touch";
const AD_DAYS = 30;
const CMP_KEY = "sht_compare_click";
const AD_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

const captureAd = () => {
  const p = new URLSearchParams(window.location.search);
  const ad = {};
  AD_PARAMS.forEach((k) => { const v = p.get(k); if (v) ad[k] = v.slice(0, 200); });
  if (!Object.keys(ad).length) return;
  if (!ad.utm_source && ad.gclid) Object.assign(ad, { utm_source: "google", utm_medium: ad.utm_medium || "cpc" });
  if (!ad.utm_source && ad.fbclid) Object.assign(ad, { utm_source: "facebook", utm_medium: ad.utm_medium || "paid_social" });
  localStorage.setItem(AD_KEY, JSON.stringify({ ad, at: Date.now() }));
};

const currentAd = () => {
  try {
    const v = JSON.parse(localStorage.getItem(AD_KEY) || "null");
    if (v && Date.now() - v.at < AD_DAYS * 86400000) return v.ad;
  } catch (e) { /* ignore */ }
  return null;
};

export const initLeadSource = () => {
  try { captureAd(); } catch (e) { /* storage blocked */ }
  try {
    if (!sessionStorage.getItem(KEY) && !window.location.pathname.startsWith("/admin")) {
      sessionStorage.setItem(KEY, window.location.pathname);
    }
  } catch (e) { /* storage blocked */ }
};

// Called when a visitor clicks a quote or call button on the comparison page.
export const markCompareClick = (action) => {
  try { localStorage.setItem(CMP_KEY, JSON.stringify({ action, at: Date.now() })); } catch (e) { /* storage blocked */ }
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/compare-click?action=${action}`, { method: "POST", keepalive: true }).catch(() => {});
};

const compareClick = () => {
  try {
    const v = JSON.parse(localStorage.getItem(CMP_KEY) || "null");
    if (v && Date.now() - v.at < AD_DAYS * 86400000) return v.action;
  } catch (e) { /* ignore */ }
  return "";
};

export const leadSource = () => {
  let landing = "";
  try { landing = sessionStorage.getItem(KEY) || ""; } catch (e) { /* storage blocked */ }
  const out = { landing_page: landing || window.location.pathname, submit_page: window.location.pathname };
  const ad = currentAd();
  if (ad) out.ad = ad;
  const cmp = compareClick();
  if (cmp) out.compare_click = cmp;
  return out;
};

export const appendLeadSource = (fd) => {
  Object.entries(leadSource()).forEach(([k, v]) => fd.append(k, typeof v === "string" ? v : JSON.stringify(v)));
  return fd;
};
